import {JournalChat} from './JournalChat';
export default JournalChat;
